import { bool, number, object } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateTableSettings, ValueCell } from "@tools";
import { TaskWorkType } from "./components/TaskWorkType";
import { CombinedTaskWorkType } from "./components/CombinedTaskWorkType";

export const TaskEstimatesCell = observer(({
  element,
  tableDepth,
  expanded,
  isSectionRow,
  extendPadding,
}) => {
  const {
    visibleWorkTypes,
    showCombinedHours,
    emptyWorkTypeCells,
    totalEstimateCells,
  } = useEstimateTableSettings();
  
  /** @note: this is left for compatibility reasons ?? or maybe we should set type of FP children to FP ? */
  // const {
  //   type,
  //   hasChildrenHours,
  //   parentHoldsFixedPrice,
  //   parentHoldsMaterialPrice,
  // } = element;
  
  // const emptyValue = (type === TaskTypes.FIXED_PRICE && !hasChildrenHours) || parentHoldsFixedPrice || parentHoldsMaterialPrice
  
  return <>
    {
      !showCombinedHours && emptyWorkTypeCells > 0 &&
      [...new Array(emptyWorkTypeCells).keys()].map((i) => (
        <ValueCell key={`placeholder${i}`} size="small" />
      ))
    }
    {
      !showCombinedHours &&
      visibleWorkTypes?.map((workType, index) => (
        <TaskWorkType
          key={workType.id}
          element={element}
          workType={workType}
          textPresetClass={isSectionRow ? "sectionTitle" : "preset-text"}
          expanded={expanded}
          tableDepth={tableDepth}
          navigationKey={`bd-wt${index+1}`}
          extendPadding={extendPadding}
        />
      ))
    }
    {
      showCombinedHours && totalEstimateCells > 0 &&
      <CombinedTaskWorkType
        element={element}
        expanded={expanded}
        extendPadding={extendPadding}
      />
    }
  </>
});

TaskEstimatesCell.propTypes = {
  element: object.isRequired,
  tableDepth: number,
  expanded: bool,
  extendPadding: bool,
  isSectionRow: bool,
};
